import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ControlledCheckbox, ControlledInput, Section, FormGrid } from '../../../shared';

interface Props {
    id?: string;
}

export const ProductData: FC<Props> = ({ id }) => {
    const { t } = useTranslation();

    return (
        <Section title={t('data')}>
            <FormGrid>
                <ControlledInput name="name" label={t('name')} required sx={{ minWidth: '500px' }} />
                <ControlledInput name="brandName" label={t('brandName')} />
                <ControlledInput name="regulatedName" label={t('regulatedName')} />
                {id && <ControlledInput name="code" label={t('code')} disabled />}
            </FormGrid>
            <ControlledCheckbox name="requiresReservation" label={t('requiresReservation')} sx={{ pl: 0 }} />
        </Section>
    );
};
